import React, { useEffect } from "react"
import FooterComponent from "../../components/footer"
import ReactHelmet from "src/components/react-helmet"

const StClairAve = () => {
  useEffect(() => {
    try {
      var script = document.createElement("script")
      script.src = "https://paperform.co/__embed"
      script.async = true
      document.body.appendChild(script)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ReactHelmet
        url="toronto-st-clair-ave"
        title="Toronto St Clari Ave"
        description="Tolobi - Rental Made Easy"
      />
      <div data-paperform-id="starlight-toronto-st-clair-ave-christie"></div>
      <FooterComponent />
    </>
  )
}

export default StClairAve
